<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { checkDomain, checkInput } from "./common.js";
    import objectStore from "./store.js";

    export let api;
    const dispatch = createEventDispatcher();
    $: good =
        sub &&
        checkDomain(sub) &&
        ((sub.length > 0 && isNaN(sub)) ||
            (Number(sub) < 9999 && Number(sub) > 0));

    let subBlur = false;
    let sub = "";
    let domain;
    let checked = false;
    let available = false;
    let domains = "";
    let domainslist = [];

    onMount(async () => {
        if ($objectStore && $objectStore.sub && $objectStore.domain) {
            console.log("has prev value" + $objectStore.sub);
            sub = $objectStore.sub;
            domain = $objectStore.domain;
        }

        // const response = [
        //     {
        //         id: 1,
        //         domain: "cõm.app",
        //         active: true,
        //     },
        //     {
        //         id: 2,
        //         domain: "com-get.app",
        //         active: true,
        //     },
        //     {
        //         id: 3,
        //         domain: "com-in.app",
        //         active: true,
        //     },
        //     {
        //         id: 4,
        //         domain: "com-download.app",
        //         active: true,
        //     },
        // ];
        const response = await fetch(api + "domains/search");
        const data = await response.json();
        // const data = response.json();
        // const data = response; // Simulated response for local testing
        domainslist = data.map((domain) => {
            return { ...domain, domain: "." + domain.domain };
        });
        if (!domain && domainslist.length > 0) {
            domain = domainslist[0].domain;
        }
    });

    console.log("check", checkDomain(sub));

    function handleForm() {
        console.log(sub + domain);

        // Producción: sigue haciendo la petición real
        fetch(api + "domains/isavailable?sub=" + sub + "&domain=" + domain)
            .then((response) => response.json())
            .then((json) => {
                console.log(
                    api +
                        "domains/isavailable?sub=" +
                        sub +
                        "&domain=" +
                        domain,
                );
                console.log(json);

                if (json) {
                    console.log("available");
                    available = true;
                    objectStore.updateItem({
                        available: true,
                        back: false,
                        sub: sub,
                        domain: domain,
                    });
                } else {
                    console.log("nope");
                    available = false;
                    objectStore.updateItem({ available: false });
                }

                checked = true;
                dispatch("domainchecked", {
                    available: json,
                    sub: sub,
                    domain: domain,
                });
            })
            .catch((error) => {
                console.error("Error checking domain availability:", error);
            });
    }
</script>

<div class="content">
    <h1>Domains</h1>
    <!-- <h3 style="font-weight: 400;font-size:16px;margin-bottom:30px!important;">
        Get one of our cool domains today
    </h3> -->

    <form
        id="domain-check"
        class="center-block"
        on:submit|preventDefault={handleForm}
    >
        <div style="margin-bottom:10px;">
            <input
                type="text"
                required
                name="sub"
                id="sub"
                autocomplete="off"
                class={checkInput(sub, good, true) +
                    " " +
                    (checked & (available === false) ? "err" : "noterr")}
                placeholder="Type your domain"
                bind:value={sub}
                on:blur={() => {
                    subBlur = true;
                }}
                on:focus={() => {
                    subBlur = false;
                    checked = false;
                }}
            />

            <select
                class="select-css"
                name="domain"
                id="domain"
                bind:value={domain}
            >
                {#each domainslist as domainItem (domainItem.id)}
                    <option value={domainItem.domain}
                        >{domainItem.domain}</option
                    >
                {/each}
            </select>
            <!-- <select
                class="select-css"
                name="domain"
                id="domain"
                bind:value={domain}
            > -->
            <!-- <option>cõm.app</option> -->
            <!-- <option>com-get.app</option> -->
            <!-- <option>.cõm.app</option>
                <option>.com-get.app</option>
                <option>.com-in.app</option> -->
            <!-- <option>com-in.app</option> -->
            <!-- <option>.com-4.fans</option> -->
            <!-- <option>.com-4.fun</option> -->
            <!-- <option>.com-4.sale</option> -->
            <!-- <option>.com-download.app</option> -->
            <!-- <option>.com-download.us</option> -->
            <!-- <option>.com-get.us</option> -->
            <!-- <option>.com-in.app</option> -->
            <!-- <option>.com-my.app</option> -->
            <!-- <option>.com-our.app</option> -->
            <!-- <option>.com-the.app</option> -->
            <!-- <option>.com-to.app</option> -->
            <!-- <option>.com-to.site</option> -->
            <!-- <option>.com-to.us</option> -->
            <!-- <option>.com-web.app</option> -->
            <!-- <option>.com-your.app</option> -->
            <!-- </select> -->
        </div>

        {#if checked || (!checked && sub && !good)}
            <div style="font-align: left;" id="available">
                {available ? "" : "Not Available or Incorrect Input"}
            </div>
        {/if}
        <div style="height: 10px;" />
        <button
            type="submit"
            id=""
            class="btn-svelte {good ? 'ripple good' : 'disabled'}"
            disabled={!good}
        >
            Check Availability
        </button>
    </form>

    <span style="color:#666666; font-size:14px"
        >By continuing, you agree to our</span
    >
    <a target="_blank" href="Https://ãpps.com/terms">Terms of Use</a>
</div>

<style>
    input,
    select {
        outline: none;
        border: none;
    }

    .selectdomain-left {
        border: none;
        max-width: 400px;
        width: 100%;
        width: calc(100% - 150px);
        height: 54px;
        text-align: left;
        border-right: none;
        margin: 0;
        padding-left: 10px;
        display: inline-block;
    }
    .selectdomain-right {
        padding-left: 10px;
        display: inline-block;
    }
    #sub {
        font-size: 16px;
        width: 100%;
        text-align: left;
        margin-top: 0px;
        text-transform: lowercase;
    }

    #sub.err {
        border: 1px solid #d40000;
    }
    #sub::placeholder {
        color: lightgray;
        font-size: 14px;
        text-transform: none;
    }

    #domain {
        width: 165px;
    }
    .select-css {
        float: right;
        margin-top: -40px;
        position: relative;
        color: #333;
        width: 100px;
        max-width: 170px;
        margin-right: 5px;
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
        background-repeat: no-repeat, repeat;
        background-position:
            right 0.6em top 65%,
            0 0;
        background-size:
            0.65em auto,
            100%;
        -webkit-appearance: none;
        appearance: none;
        font-size: 14px;
        background-color: white;
    }
    .select-css::-ms-expand {
        display: none;
    }
    .select-css option {
        font-weight: normal;
    }

    #available {
        text-align: center;
        /* position: absolute; */
        width: 100%;
        left: calc(50% - 125px);
        color: red;
        font-size: 0.9em;
        margin: 2px;
    }
</style>
